import cn from 'classnames'
import { type ReactElement } from 'react'

interface ButtonProps {
  additionalClasses?: string
  clickFunction: (event: React.MouseEvent<HTMLButtonElement>) => void
  text: string
}

function RedOutlineButton ({ additionalClasses, clickFunction, text }: ButtonProps): ReactElement {
  return (
    <button
      onClick={clickFunction}
      type="button"
      className={cn(additionalClasses, 'p-2 border rounded-md border-red-700 text-red-700 flex font-medium items-center justify-center ')}
    >
      {text}
    </button>
  )
}

export default RedOutlineButton
